<template>
  <v-text-field
    ref="stringInput"
    @blur="finishEdit"
    :label="required ? fieldlabel + $t('cabledesign.required') : fieldlabel"
    v-model="newValue"
    v-if="readonly != 'RO'"
    :readonly="readonly == 'WR' ? false : true"
    :maxlength="maxlength"
    :rules="rules"
    class="mt-0 pt-0"
  ></v-text-field>
  <div v-else>{{ fieldlabel }}: {{ newValue != null ? newValue : $t('cabledesign.notFilled') }}</div>
</template>

<script>
export default {
  props: ["value", "readonly", "fieldlabel", "required", "maxlength", "rules"],
  data() {
    return {
      newValue: this.value
    };
  },
  watch: {
    value() {
      this.newValue = this.value;
    }
  },
  computed: {
    sx() {
      this.$log.debug(this.suffix);
      return this.suffix;
    }
  },
  methods: {
    finishEdit() {
      // TODO to trim or not to trim?
      //      var val = this.newValue && this.newValue.trim ? this.newValue.trim() : "";
      //      val = val === "" ? null : this.newValue;
      this.$log.debug("TEXT emitting new value: " + this.newValue);
      this.$emit("change", this.newValue);
    }
  }
};
</script>
